/**
 * Decorator to be used when a debounced behaviour is needed.
 *
 * Example:
 * @HostListener('keyup', ['$event'])
 * @debounceFn(500)
 * blurUp($event: any) { ... }
 */
export function debounceFn(
  miliseconds: number = 100,
  timeoutPropertyName: string = 'timeoutFn',
): MethodDecorator {
  return (
    target: any,
    propertyKey: string | symbol,
    descriptor: TypedPropertyDescriptor<any>,
  ): TypedPropertyDescriptor<any> => {
    Object.defineProperty(target, timeoutPropertyName, {
      value: 0,
      writable: true,
    });
    const originalMethod: () => void = descriptor.value;

    descriptor.value = function () {
      if (this[timeoutPropertyName]) {
        clearTimeout(this[timeoutPropertyName]);
      }
      const args = arguments;
      this[timeoutPropertyName] = setTimeout(() => {
        originalMethod.apply(this, args);
      }, miliseconds);
    };

    return descriptor;
  };
}
